import type { CompanyConnection } from "hooks/useCompanyConnection";

export function csvCell(value: unknown) {
  const text = String(value ?? "");
  const safe =
    typeof value !== "number" && /^[=+@\-\t\r]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}

export async function completeReport<T>(
  headers: string[],
  read: (after?: string) => Promise<CompanyConnection<T>>,
  rows: (node: T, page: CompanyConnection<T>) => unknown[][],
  canceled: () => boolean = () => false,
) {
  const lines = [headers.map(csvCell).join(",")];
  const seen = new Set<string>();
  let after: string | undefined;
  do {
    const page = await read(after);
    if (canceled()) throw new Error("Export canceled");
    for (const { node } of page.edges) {
      for (const row of rows(node, page))
        lines.push(row.map(csvCell).join(","));
    }
    const next = page.pageInfo.hasNextPage ? page.pageInfo.endCursor : null;
    if (page.pageInfo.hasNextPage && (!next || seen.has(next)))
      throw new Error("Export cursor did not advance");
    if (next) seen.add(next);
    after = next || undefined;
  } while (after);
  return lines.join("\r\n");
}

export function downloadReport(csv: string, filename: string) {
  const url = URL.createObjectURL(
    new Blob([csv], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
